import React from 'react';
import StepSection from '../../../Elements/StepSection';
import DefinitionCard from '../../../Elements/DefinitionCard';

function StepSectionDemoComponent() {
  return (
    <div>
      <StepSection
        number={1}
        title='When'
        lead='When Bravo works on the drafts of this project.'
      >
        <DefinitionCard rows={[{ label: 'Runs', value: 'Automatically, every morning' }]} />
      </StepSection>
      <StepSection
        number={2}
        title='Invoice'
        lead='What goes on the invoice, and to whom.'
        isLast={true}
      >
        <DefinitionCard rows={[{ label: 'Bill to', value: 'Sam Example' }]} />
      </StepSection>
    </div>
  );
}

export const stepSectionDemo = {
  id: 'step-section',
  title: 'Step section',
  category: 'Navigation & Layout',
  importPath: 'Elements/StepSection',
  notes: [
    'A numbered step of a settings page: the number on a rail running down to the next step, an Oswald title, a lead line, then the content.',
    'Set isLast on the page’s last step to end the rail.',
    'First used by the automatic invoicing setup of a third-party project.',
  ],
  snippet:
    '<StepSection number={1} title="When" lead="When Bravo works on the drafts.">\n  <SettingRows rows={rows} />\n</StepSection>',
  render: StepSectionDemoComponent,
};
